import { config } from '@packages/shared/config';
import { Config } from '@packages/shared/interfaces';
import { AppName } from '@packages/shared/core/common/entities';

export const guidanceConfig: Config = {
  ...config,
  appName: AppName.GUIDANCE,
  appOrigin: {
    ...config.appOrigin,
    default: process.env.NEXT_PUBLIC_GUIDANCE_ORIGIN || '',
  },
};
